import { I18NextPipe } from 'angular-i18next';
import { ThresholdUnitsType } from 'mbs-ui-shared@models/Notification';

export const thresholdUnits = (i18N: I18NextPipe): { id: ThresholdUnitsType; name: string }[] => [
  {
    id: 'days',
    name: i18N.transform('shared:notifications.thresholdUnitDay', { count: 2 })
  },
  {
    id: 'hours',
    name: i18N.transform('shared:notifications.thresholdUnitHour', { count: 2 })
  }
];
